import React, {Component} from 'react';
import API from "../../services/API";
class Rules extends Component {
    state={
        content : ''
    }
    render() {
        return (
            <section className="container rtl mt-5">
                <div className="row">
                    <div className="col-12">
                        <h2 className="fw-bold text-secondary">
                            قوانین و مقررات
                        </h2>
                    </div>
                    <div className="col-12 p-5 mt-5 usual-content">
                        <p  dangerouslySetInnerHTML={{ __html: this.state.content }}></p>

                    </div>
                    <div className="col-12  my-3 text-left ">
                        <button className="btn btn-primary w-50 " onClick={() => this.props.history.push("/login")}>
                            تایید
                        </button>
                    </div>
                </div>
            </section>
        );
    }
    componentDidMount = () =>{
        API.usualContent('rules')
            .then((response) => {
               const content = response.results.content;
               this.setState({content});
            })
    }
}

export default Rules;